import React, { useEffect, useState } from "react";
import "./State.css";
import { MdDeleteOutline } from "react-icons/md";
import { FaDownload } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa";

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  return isOpen ? (
    <div className="modal-overlay">
      <div className="modal-container">
        <h3>Are you sure you want to delete this item?</h3>
        <div className="modal-actions">
          <button className="confirm-btn" onClick={onConfirm}>
            Yes
          </button>
          <button className="cancel-btn" onClick={onClose}>
            No
          </button>
        </div>
      </div>
    </div>
  ) : null;
};

function Table({
  getTableData,
  selectedTable,
  selectedState,
  selecteddivision,
  selectedyear,
  selectedmonth,
  selectedid,
  register,
  remittance,
  returns,
  certifications,
  company,
}) {
  const userDetails = JSON.parse(localStorage.getItem("userdetails"));
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState(null);

  // const handlesaved = (selectedyear, selectedmonth, selecteddivision, selectedid) => {
  //   const clientdetails = JSON.parse(localStorage.getItem('clientdetails')) || {}; // Add this line to define clientdetails
  //   // Check if all fields are filled (add appropriate checks for other fields as needed)
  //   if (Object.keys(files).length > 0) { // Check if there are files in the state
  //     const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/fileupload.php`;
  //     // const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/upload_audit_docs.php`;
  //     const formData = new FormData();
  //     const userDetails = JSON.parse(localStorage.getItem('userdetails')); // Assuming this is available as per your code

  //     // Append all necessary data to the FormData object
  //     Object.entries(files).forEach(([file]) => {
  //       formData.append("file", file); // Append the file with a key of 'file'
  //       // Append file id (or other metadata)
  //       formData.append("upload_by", userDetails.username); // Username from localStorage
  //       formData.append("user_id", selectedid); // User ID from localStorage
  //       formData.append("year", selectedyear); // Selected year from state
  //       formData.append("month", selectedmonth); // Selected month from state
  //       formData.append("division", selecteddivision); // Selected division from state
  //       formData.append("audit_docs_id", "2");

  //       // Optionally: Append state or other information
  //       // formData.append("state", selectedState); // Assuming `selectedState` is available

  //       // Send the request
  //       fetch(apiUrl, {
  //         method: "POST",
  //         body: formData
  //       })
  //         .then(response => response.json())
  //         .then(data => {
  //           alert(data.message); // Display response message
  //         })
  //         .catch(error => {
  //           console.log("Error with POST request:", error);
  //           alert("Error uploading file. Please try again.");
  //         });
  //     });
  //   } else {
  //     alert('Please select a file to upload!');
  //   }
  // };

  const [selectedFiles, setSelectedFiles] = useState({});
  const [loading, setLoading] = useState(false);

  // file saving function
  const updateFileName = (event) => {
    const files = event.target.files; // Allow multiple file selection
    const fileId = event.target.getAttribute("data-id"); // Get row-specific file ID

    if (!files.length) {
      console.error("No file selected!");
      alert("Please select a file before uploading.");
      return;
    }

    setSelectedFiles((prevFiles) => ({
      ...prevFiles,
      [fileId]: files[0], // Store file with corresponding row ID
    }));

    console.log(`File selected for ID ${fileId}:`, files[0].name);
  };

  // Function to handle file upload
  const handlesave = () => {
    const base = company ? "vendors" : "clients";
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/${base}/fileupload.php`;
    const formData = new FormData();

    if (!selectedFiles || Object.keys(selectedFiles).length === 0) {
      console.error("No files selected!");
      alert("Please select at least one file before uploading.");
      return;
    }

    Object.entries(selectedFiles).forEach(([fileId, file]) => {
      formData.append("files[]", file);
      formData.append("audit_docs_ids[]", fileId);
    });

    formData.append("upload_by", userDetails?.username);
    if (company) {
      formData.append("user_id", userDetails?.userid);
    } else {
      formData.append("user_id", selectedid);
    }

    formData.append("year", selectedyear);
    formData.append("month", selectedmonth);
    if (company) {
    } else {
      formData.append("division", selecteddivision);
      // formData.append("upload_by", userDetails?.username);
    }

    console.log("Uploading formData:", Object.fromEntries(formData));

    setLoading(true);

    fetch(apiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Server Response:", data);
        alert(
          data
            .map((item) => `${item.file}: ${item.message || item.error}`)
            .join("\n")
        );
        setLoading(false);
        getTableData();
      })
      .catch((error) => {
        alert("Error uploading file. Please try again.");
        console.log("Error with POST request:", error);
        setLoading(false);
      });
  };

  const handleView = async (fileId) => {
    try {
      const base = company ? "vendors" : "clients";
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/${base}/filedownload.php?id=${fileId}`
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }

      const blob = await response.blob();
      const fileUrl = URL.createObjectURL(blob);

      // Open the file in a new tab for viewing
      const newTab = window.open(fileUrl, "_blank");
      if (!newTab) {
        alert("Pop-up blocked! Please allow pop-ups for this site.");
      }

      // Revoke object URL after some time to free memory
      setTimeout(() => URL.revokeObjectURL(fileUrl), 60000);
    } catch (error) {
      console.error("View error:", error);
      alert(`View failed: ${error.message}`);
    }
  };

  // how to download the file from the server
  const handleDownload = async (fileId, rowId) => {
    try {
      if (userDetails?.role !== "vendor") {
        const formData = new FormData();
        formData.append("id", rowId);
        formData.append("download_by", userDetails?.id);
      }
      const base = company ? "vendors" : "clients";
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/${base}/filedownload.php?id=${fileId}`
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }

      const blob = await response.blob();
      let downloadName = "downloaded-file";

      const disposition = response.headers.get("Content-Disposition");
      const match = disposition?.match(/filename="?([^"]+)"?/);
      if (match?.[1]) downloadName = match[1];

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = downloadName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert(`Download failed: ${error.message}`);
    }
  };

  const handleDelete = (fileId) => {
    if (!fileId) {
      alert("No file selected for deletion or file does not exist!");
      return;
    }

    console.log("Selected File ID for deletion:", fileId); // Debugging

    setSelectedFileId(fileId); // Store the selected file ID
    setModalOpen(true); // Open confirmation modal
  };
  const confirmDelete = async () => {
    if (!selectedFileId) {
      alert("No file selected for deletion!");
      return;
    }

    const base = company ? "vendors" : "clients";
    const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/${base}/filedelete.php`;
    const formData = new FormData();

    formData.append("audit_docs_id", selectedFileId);
    formData.append("user_id", selectedid);
    formData.append("year", selectedyear);
    formData.append("month", selectedmonth);
    formData.append("division", selecteddivision);

    try {
      const response = await fetch(apiUrl, { method: "POST", body: formData });
      const text = await response.text();
      console.log("Raw response:", text);

      const data = JSON.parse(text);

      if (data.success) {
        alert("File deleted successfully!");
        setModalOpen(false);
        getTableData();
        // if (typeof getTableData === "function") { // ✅ Check before calling
        //   console.log("Calling getTableData...");
        //   getTableData();
        // } else {
        //   console.error("Error: getTableData is not a function");
        // }
      } else {
        alert(data.message || "Failed to delete file.");
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
      alert("An error occurred. Please check the console.");
    }
  };
  const cancelDelete = () => {
    setModalOpen(false);
  };
  useEffect(() => {
    getTableData();
  }, [
    selectedTable,
    selectedState,
    selecteddivision,
    selectedyear,
    selectedmonth,
    selectedid,
  ]);

  return (
    <div className="tamilnadu-container">
      {loading ? (
        <>
          {loading && (
            <div className="loading-overlay">
              <div className="loader"></div>
              <p>File is uploading, please wait...</p>
            </div>
          )}
        </>
      ) : (
        <>
          {["register", "remittance", "returns", "certifications"].includes(
            selectedTable
          ) && (
            <div className="table-register-table">
              <table className="audit-table" id="myTable">
                <thead>
                  <tr>
                    <td className="reg" colSpan={10}>
                      Audit Portal Statutory Documents Upload -{" "}
                      {userDetails?.role === "vendor" ||
                        (userDetails?.role === "client" &&
                          (userDetails.state === "tamil_nadu"
                            ? "Tamil Nadu"
                            : userDetails.state === "maharashtra"
                            ? "Maharashtra"
                            : userDetails.state === "odisha"
                            ? "Odisha"
                            : userDetails.state === "karnataka"
                            ? "Karnataka"
                            : null)) ||
                        (selectedState === "tamil_nadu"
                          ? "Tamil Nadu"
                          : selectedState === "maharashtra"
                          ? "Maharashtra"
                          : selectedState === "odisha"
                          ? "Odisha"
                          : selectedState === "karnataka"
                          ? "Karnataka"
                          : selectedState)}
                    </td>
                  </tr>
                  <tr>
                    {/* <td className="reg" colSpan={9}>Registers</td> */}
                    <td className="reg" colSpan={10}>
                      {selectedTable.charAt(0).toUpperCase() +
                        selectedTable.slice(1)}
                    </td>
                  </tr>
                  <tr>
                    <th>Sno</th>
                    <th>Select Act</th>
                    <th>Forms</th>
                    <th>Frequency</th>
                    <th>File</th>

                    {(
                      { register, remittance, returns, certifications }[
                        selectedTable
                      ] || []
                    ).some((item) => item.file) &&
                      userDetails?.role === "sadmin" && <th>Upload by</th>}

                    {(
                      { register, remittance, returns, certifications }[
                        selectedTable
                      ] || []
                    ).some((item) => item.file) && <th>View</th>}

                    {(
                      { register, remittance, returns, certifications }[
                        selectedTable
                      ] || []
                    ).some((item) => item.file) && <th>Download</th>}

                    {(
                      { register, remittance, returns, certifications }[
                        selectedTable
                      ] || []
                    ).some((item) => item.file) &&
                      (userDetails?.role === "sadmin" ||
                        userDetails?.role === "vendor") && <th>Delete</th>}
                  </tr>
                </thead>
                <tbody>
                  {(
                    { register, remittance, returns, certifications }[
                      selectedTable
                    ] || []
                  ).map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td className="left">{item?.act}</td>
                      <td className="left">{item?.forms}</td>
                      <td>{item.frequency}</td>

                      {item.file ? (
                        <>
                          <td>
                            {item.file ? (
                              <>
                                <span>{item.file}</span>
                              </>
                            ) : (
                              <input
                                type="file"
                                className="file-input"
                                data-id={item.id}
                                onChange={updateFileName}
                              />
                            )}
                          </td>

                          {userDetails?.role === "sadmin" && (
                            <td>{item.upload_by}</td>
                          )}

                          <td>
                            <button
                              className="view-btn"
                              onClick={() => handleView(item.file)}
                            >
                              <span className="butt">
                                <FaRegEye />
                              </span>
                            </button>
                          </td>

                          <td>
                            <button
                              className="download-btn"
                              onClick={() =>
                                handleDownload(item.file, item.c_id)
                              }
                            >
                              <span className="butt">
                                <FaDownload />
                              </span>
                            </button>
                          </td>

                          {(userDetails?.role === "sadmin" ||
                            userDetails?.role === "vendor") && (
                            <td>
                              <button
                                className="delete-btn"
                                onClick={() => handleDelete(item.id)}
                              >
                                <span className="butt">
                                  <MdDeleteOutline />
                                </span>
                              </button>
                            </td>
                          )}
                        </>
                      ) : (
                        <>
                          <td colSpan={5}>
                            <input
                              type="file"
                              className="file-input"
                              data-id={item.id}
                              onChange={updateFileName}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              {userDetails?.role === "vendor" ||
                (userDetails?.role !== "client" && (
                  <div className="upload_btn">
                    <button
                      className="upload-btn"
                      onClick={handlesave}
                      disabled={loading}
                    >
                      {loading ? "Uploading..." : "Save"}
                    </button>
                  </div>
                ))}
            </div>
          )}
        </>
      )}

      <DeleteConfirmationModal
        isOpen={isModalOpen}
        onClose={cancelDelete}
        onConfirm={confirmDelete}
      />
    </div>
  );
}

export default Table;
